import React, { Component } from "react";
import { connect } from "react-redux";
import { setFilter } from "Actions";
import { fetchMed } from "Thunks";

import SearchComponent from "./SearchComponent";

export class Search extends Component {
  render() {
    return <SearchComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({
  filter: state.filter.filterState,
  lng: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  setFilter: params => dispatch(setFilter(params)),
  fetchMedias: params => dispatch(fetchMed(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);



// WEBPACK FOOTER //
// ./src/components/Community/Header/Search/index.js